import type { ClassicSort } from '~/lib/classic-sorting'

// The Classic sort control's glyph: three lines at rest, an arrow beside
// shorter lines for the two price sorts. 24px, stroked in `currentColor` so
// it follows the button's text colour.
export function SortIcon(props: { sort: ClassicSort }) {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      class="size-6"
    >
      {props.sort === 'default' ? (
        <path
          d="M4 7h16M7 12h10M10 17h4"
          stroke-linecap="round"
          stroke-width="1.8"
        />
      ) : (
        <>
          <path
            d={
              props.sort === 'price-descending'
                ? 'M7 5v14m0 0-3-3m3 3 3-3'
                : 'M7 19V5m0 0L4 8m3-3 3 3'
            }
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1.8"
          />
          <path
            d="M13 7h7m-7 5h5m-5 5h3"
            stroke-linecap="round"
            stroke-width="1.8"
          />
        </>
      )}
    </svg>
  )
}
